// src/i18n/shell.ts —— 06 U-20 / U-21；跨域共用文案键（费率 / 欠费键、U-17 / U-18 feeOwedLabel / feeNoRefundTip 由 cards 与 wallet 域只引用，不重复定义）；
// featurePending（未就绪端点统一提示，TD-813）；retry（U-22 E-04 次级列表首屏失败重试）
export const I18N_SHELL = {
  zh: {
    sessionExpired: '会话已过期，请关闭后重新打开小程序', miniClosed: 'Mini App 已在后台关闭',
    totpTitle: '输入动态验证码', totpSub: '打开验证器 App 查看 6 位动态码', totpWaitNext: '请等待验证器刷新后输入新的动态码',
    closeFee: '销卡费', txFee: '消费手续费', crossBorderFee: '跨境手续费', declinedFee: '交易拒绝手续费', disputeFee: '争议费',
    feeOwedAdded: '已记欠费 {owed} USDT',
    feeOwedLabel: '计入欠费', feeNoRefundTip: '交易手续费不随后续退款或争议结果退回',
    featurePending: '该功能即将开放',
    retry: '重试',
  },
  en: {
    sessionExpired: 'Session expired. Please close and reopen the mini app', miniClosed: 'This mini app has been turned off',
    totpTitle: 'Enter authenticator code', totpSub: 'Open your authenticator app for the 6-digit code', totpWaitNext: 'Wait for your authenticator to show a new code',
    closeFee: 'Close fee', txFee: 'Spend fee', crossBorderFee: 'Cross-border fee', declinedFee: 'Decline fee', disputeFee: 'Dispute fee',
    feeOwedAdded: '{owed} USDT added to fee arrears',
    feeOwedLabel: 'Added to arrears', feeNoRefundTip: "Transaction fees aren't refunded if the purchase is later refunded or disputed",
    featurePending: 'Coming soon',
    retry: 'Retry',
  },
} as const;
